import { createLcg } from "../rng/lcg.js";
import { shuffle } from "../rng/shuffle.js";
import type { CardInstance } from "../types/index.js";

export type DrawInput = {
  deck: CardInstance[];
  discard: CardInstance[];
  rngState: number;
};

export type DrawResult = DrawInput & {
  drawn: CardInstance[];
  reshuffled: boolean;
};

function reshuffleDiscardIntoDeck(
  deck: CardInstance[],
  discard: CardInstance[],
  rngState: number,
): { deck: CardInstance[]; discard: CardInstance[]; rngState: number } {
  if (discard.length === 0) {
    return { deck, discard, rngState };
  }

  const rng = createLcg(rngState);
  const shuffled = shuffle(discard, rng);

  return {
    deck: shuffled,
    discard: [],
    rngState: rng.state,
  };
}

export function draw(input: DrawInput, count: number): DrawResult {
  let deck = input.deck.slice();
  let discard = input.discard.slice();
  let rngState = input.rngState;
  const drawn: CardInstance[] = [];
  let reshuffled = false;
  let remaining = Math.max(0, count);

  while (remaining > 0) {
    if (deck.length === 0) {
      reshuffled = discard.length > 0;
      const refilled = reshuffleDiscardIntoDeck(deck, discard, rngState);
      deck = refilled.deck;
      discard = refilled.discard;
      rngState = refilled.rngState;
    }

    if (deck.length === 0) {
      break;
    }

    const card = deck.pop();
    if (!card) {
      break;
    }

    drawn.push(card);
    remaining -= 1;
  }

  return { deck, discard, rngState, drawn, reshuffled };
}
